import React, { useContext, useEffect, useState } from "react";
import { ErrorMessage, Formik } from "formik";
import {
  Alert,
  Form,
  Card,
  Row,
  Col,
  Accordion,
  Button,
} from "react-bootstrap";
import * as Yup from "yup";
import axios from "axios";
import moment from "moment";
import { getInputClasses } from "../../../_utils/getInputclasses";
import AlertError from "../../../components/AlertError";
import { update } from "../../services/hospitalizationcrud";
import { getAll } from "../../services/axaService";
import { getByPolicy as getInsurancePolicyByPolicy } from "../../services/insurancePoliciesService";
import {AxaCategoriesOthersNotVisible, AxaCategoriesVip} from "../../../helpers/constants";
import IncomeTypeContext from "../../../contexts/IncomeTypeContext";

export const InssuredData = (props) => {
  return (
    <>
      <Card>
        <Card.Header>
          <Accordion.Toggle
            as={Button}
            variant="link"
            eventKey={props.eventKey}
          >
            Datos Asegurado
          </Accordion.Toggle>
          <i className={`fa ${props.icon}`} style={{position:"absolute", right:"0", marginRight:"15px", marginTop:"10px" }}></i>
          <i className={`fa ${props.icone}`} style={{position:"absolute", right:"0", marginRight:"35px", marginTop:"10px" }}></i>
        </Card.Header>
        <Accordion.Collapse eventKey={props.eventKey}>
          <Card.Body>
            <ContentInssuredData {...props} />
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </>
  );
};

export const ContentInssuredData = (props) => {
  return (
    <>
      <Alert
        variant="dark"
        className="text-center"
        style={{ fontSize: "14px" }}
      >
        Datos Asegurado
      </Alert>

      {!props.disabledAll && (
        <div style={{ backgroundColor: "#d6eaf8", color: "#1a5276", fontSize: "13px", padding: "10px 15px", borderRadius: "4px", marginBottom: "15px" }}>
          NOTA: FAVOR DE CAPTURAR LA INFORMACION EXCLUSIVAMENTE DEL ASEGURADO (POLIZA, CODIGO DEL CLIENTE, TELEFONO ASEGURADO O FAMILIAR RESPONSABLE, CORREO ELECTRONICO ASEGURADO O FAMILIAR RESPONSABLE)
        </div>
      )}

      <Card>
        <Card.Body>
          <FormInssuredData {...props} />
        </Card.Body>
      </Card>
    </>
  );
};

export const FormInssuredData = (props) => {
  const [initialValues, setInitialValues] = useState ({
    assuredFlastname: props.data.assuredFlastname || "",
    policy: props.data.policy || "",
    assuredMlastname: props.data.assuredMlastname || "",
    clientCertificate: props.data.clientCertificate || "",
    assuredName: props.data.assuredName || "",
    atentionIden: props.data.atentionIden || "",
    assuredEmail: props.data.assuredEmail || "",
    assuredPhone: props.data.assuredPhone || "",
    identificator: props.data.identificator || "",
    assuredBrthdate: props.data.assuredBrthdate || "",
    opinionIden: props.data.opinionIden || "",
    incomeAreaId: props.data.incomeAreaId || "",
    incomeDatetime: props.data.incomeDatetime || "",
    hospitalIden: props.data.hospitalIden || "",
    room: props.data.room || "",
    symptom: props.data.symptom || "",
    diagnosis: props.data.diagnosis || "",
    vip: props.data.vip || "",
    axaCategories: props.data.axaCategories || '',
    hospitalCategory: props.data.hospitalCategory || '',
  });

  const [axas, setAxas] = useState([]);
  const [axaCategories] = useState([]);
  const [timestamp, setTimestamp] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [vip, setVip] = useState("No");
  const [categoryAxaEnabled, setCategoryAxaEnabled]= useState(true);
  const { id } = props.data;
  const { bindSubmitForm, bindErrors } = props;


  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(0);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [input, setInput] = useState("");

  const [incomeType] = useContext(IncomeTypeContext);
  const isSurgery = incomeType === "Programacion de cirugia";

  const [hospitalCategoryLookup, setHospitalCategoryLookup] = useState({
    status: "idle", // idle | loading | found | notFound | error
    value: "",
  });

  let curr = new Date();
  let todayDate = curr.toISOString().substr(0, 10);

  const handleSubmitForm = (values, { setStatus, setSubmitting }) => {
    update({ ...props.data, ...values }, id).then((response) =>
      console.log("Form inssured data inside saved")
    );
  };

  useEffect(() => {
    setInitialValues({
      assuredFlastname: props.data.assuredFlastname || "",
      policy: props.data.policy || "",
      assuredMlastname: props.data.assuredMlastname || "",
      clientCertificate: props.data.clientCertificate || "",
      assuredName: props.data.assuredName || "",
      atentionIden: props.data.atentionIden || "",
      assuredEmail: props.data.assuredEmail || "",
      assuredPhone: props.data.assuredPhone || "",
      identificator: props.data.identificator || "",
      assuredBrthdate: props.data.assuredBrthdate || "",
      opinionIden: props.data.opinionIden || "",
      incomeAreaId: props.data.incomeAreaId || "",
      incomeDatetime: props.data.incomeDatetime || "",
      hospitalIden: props.data.hospitalIden || "",
      room: props.data.room || "",
      symptom: props.data.symptom || "",
      diagnosis: props.data.diagnosis || "",
      vip: props.data.vip || "",
      axaCategories: props.data.axaCategories || '',
      hospitalCategory: props.data.hospitalCategory || '',
    });

    getAll().then((response) =>  setAxas(response.data?.filter(category => AxaCategoriesVip.includes(category.axaCatDescription) || AxaCategoriesOthersNotVisible.includes(category.axaCatDescription) )));
    axios.get('/cases/getTimestamp').then(response => setTimestamp(response.data));
    getPolicyVip();

    if (props.data.policy)
      setInput(props.data.policy);

    if (props.data.hospitalCategory) {
      setHospitalCategoryLookup({ status: "found", value: props.data.hospitalCategory });
    }
  }, [props.data]);

  // Debounced lookup of hospital category by policy value.
  // Hits backend after 500ms of inactivity. Skips lookups for short inputs.
  useEffect(() => {
    if (!input || input.length < 4) {
      setHospitalCategoryLookup({ status: "idle", value: "" });
      return;
    }

    setHospitalCategoryLookup((prev) => ({ status: "loading", value: prev.value }));

    const handle = setTimeout(() => {
      getInsurancePolicyByPolicy(input)
        .then((response) => {
          const record = response?.data;
          if (record && record.hospitalCategory) {
            setHospitalCategoryLookup({ status: "found", value: record.hospitalCategory });
          } else {
            setHospitalCategoryLookup({ status: "notFound", value: "" });
          }
        })
        .catch(() => {
          setHospitalCategoryLookup({ status: "error", value: "" });
        });
    }, 500);

    return () => clearTimeout(handle);
  }, [input]);

  const validationSchema = Yup.object().shape({
    assuredFlastname: Yup.string()
        .required("El campo es requerido"),
    assuredMlastname: Yup.string()
      .required("El campo es requerido"),
    assuredName: Yup.string()
      .required("El campo es requerido"),
    assuredEmail: Yup.string()
      .required("El campo es requerido")
      .email("El campo no parece ser un email"),
    incomeDatetime: Yup.string()
      .required("El campo es requerido"),
    hospitalIden: Yup.string()
      .required("El campo es requerido"),
    diagnosis: Yup.string()
      .required("El campo es requerido"),
    policy: Yup.string()
      .required("El campo es requerido"),
    clientCertificate: Yup.string()
      .required("El campo es requerido"),
    assuredPhone: Yup.string()
      .required("El campo es requerido")
      .matches(/^[0-9]{10}$/, "El teléfono debe ser de 10 dígitos numéricos"),
    atentionIden: isSurgery
      ? Yup.string().required("El campo Folio EP es requerido")
      : Yup.string(),
    identificator: isSurgery
      ? Yup.string().required("El campo Folio IH es requerido")
      : Yup.string(),
    opinionIden: isSurgery
      ? Yup.string().required("El campo Siniestro es requerido")
      : Yup.string(),
  });

  const getPolicyVip = async () => {
      let data = await axios.get(`/vip_policy`);
      setSuggestions(data.data);
  }

  const SuggestionsListComponent = ({ setFieldValue }) => {
    return filteredSuggestions.length ? (
      <ul className="suggestions">
        {filteredSuggestions.map((suggestion, index) => {
          let className;
  
          // Flag the active suggestion with a class
          if (index === activeSuggestionIndex) {
            className = "suggestion-active";
          }
  
          return (
            <li className={className} key={index}  onClick={e => {
              onClick(e, suggestion.value);
              setFieldValue("policy", suggestion.value);
              setFieldValue("axaCategories", suggestion.source);
            }}>
              {suggestion.label}
            </li>
          );
        })}
      </ul>
    ) : (
      <div className="no-suggestions"></div>
    );
  }

  const onChange = (e) => {
    const userInput = e.target.value;
    
    // Filter our suggestions that don't contain the user's input
    const unLinked = suggestions.filter(
      (suggestion) =>
        suggestion.value.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );

    setInput(e.target.value);
    setFilteredSuggestions(unLinked);
    setActiveSuggestionIndex(0);
    setShowSuggestions(true);
    setVip("No");
  }

  const onClick = (e, suggestion) => {
    setFilteredSuggestions([]);
    setInput(suggestion);
    setActiveSuggestionIndex(0);
    setShowSuggestions(false);
    setVip("Si");
    setCategoryAxaEnabled(true);
  }

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{ ...initialValues, axaCategoriesArray: axaCategories }}
      onSubmit={handleSubmitForm}
      validationSchema={validationSchema}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        status,
        isSubmitting,
        submitForm,
        setFieldValue,
      }) => {
        bindSubmitForm(submitForm);
        if (bindErrors) bindErrors(errors);
        return (
          <>
            <AlertError status={status} />
            <Form id="formu2" onSubmit={handleSubmit}>
              <input type="hidden" value={vip} name="vip" />

              {/* Fila 1: Apellido Paterno, Apellido Materno, Nombre */}
              <Row>
                <Col>
                  <Form.Group controlId="assuredFlastname">
                    <Form.Label>Apellido Paterno *</Form.Label>
                    <Form.Control
                      type="text"
                      name="assuredFlastname"
                      value={values.assuredFlastname}
                      onChange={handleChange}
                      disabled={props.disabledAll}
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "assuredFlastname"
                      )}`}
                    />
                    <ErrorMessage name="assuredFlastname">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>

                <Col>
                  <Form.Group controlId="assuredMlastname">
                    <Form.Label>Apellido Materno *</Form.Label>
                    <Form.Control
                      type="text"
                      name="assuredMlastname"
                      value={values.assuredMlastname}
                      onChange={handleChange}
                      disabled={props.disabledAll}
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "assuredMlastname"
                      )}`}
                    />
                    <ErrorMessage name="assuredMlastname">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>

                <Col>
                  <Form.Group controlId="assuredName">
                    <Form.Label>Nombre(s) *</Form.Label>
                    <Form.Control
                      type="text"
                      name="assuredName"
                      value={values.assuredName}
                      onChange={handleChange}
                      disabled={props.disabledAll}
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "assuredName"
                      )}`}
                    />
                    <ErrorMessage name="assuredName">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>
              </Row>

              {/* Fila 2: Fecha de Nacimiento, Teléfono, Correo */}
              <Row>
                <Col>
                  <Form.Group controlId="assuredBrthdate">
                    <Form.Label>Fecha de Nacimiento</Form.Label>
                    <Form.Control
                      type="date"
                      name="assuredBrthdate"
                      value={values.assuredBrthdate}
                      onChange={handleChange}
                      disabled={props.disabledAll}
                      max={todayDate}
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "assuredBrthdate"
                      )}`}
                    />
                    <ErrorMessage name="assuredBrthdate">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>

                <Col>
                  <Form.Group controlId="assuredPhone">
                    <Form.Label>Teléfono del Asegurado *</Form.Label>
                    <Form.Control
                      type="text"
                      name="assuredPhone"
                      value={values.assuredPhone}
                      onChange={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                        handleChange(e);
                      }}
                      disabled={props.disabledAll}
                      maxLength="10"
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "assuredPhone"
                      )}`}
                    />
                    <ErrorMessage name="assuredPhone">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>

                <Col>
                  <Form.Group controlId="assuredEmail">
                    <Form.Label>Correo Electrónico Asegurado *</Form.Label>
                    <Form.Control
                      type="email"
                      name="assuredEmail"
                      value={values.assuredEmail}
                      onChange={handleChange}
                      disabled={props.disabledAll}
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "assuredEmail"
                      )}`}
                    />
                    <ErrorMessage name="assuredEmail">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>
              </Row>

              {/* Fila 3: Póliza, Código cliente, [Tipo de poliza | nada en cirugía] */}
              <Row>
                <Col>
                  <Form.Group controlId="policy">
                    <Form.Label>Póliza *</Form.Label>
                    <Form.Control
                      type="text"
                      name="policy"
                      value={input}
                      onChange={ e => {
                        onChange(e);
                        setFieldValue("policy", e.target.value);
                        setFieldValue("axaCategories", "");
                      }}
                      disabled={props.disabledAll}
                      autoComplete="off"
                      maxLength="8"
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "policy"
                      )}`}
                    />
                    {showSuggestions && input && input.length >= 7 && <SuggestionsListComponent setFieldValue={setFieldValue} />}
                    <ErrorMessage name="policy">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>

                <Col>
                  <Form.Group controlId="clientCertificate">
                    <Form.Label>Código de cliente/ Certificado *</Form.Label>
                    <Form.Control
                      type="text"
                      name="clientCertificate"
                      value={values.clientCertificate}
                      onChange={handleChange}
                      disabled={props.disabledAll}
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "clientCertificate"
                      )}`}
                    />
                    <ErrorMessage name="clientCertificate">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>

                {!isSurgery && (
                  <Col>
                    <Form.Group controlId="axaCategories">
                      <Form.Label>Tipo de poliza</Form.Label>
                      <Form.Control
                        as="select"
                        name="axaCategories"
                        value={values.axaCategories}
                        onChange={handleChange}
                        disabled={props.disabledAll || categoryAxaEnabled}
                        className={`${getInputClasses(
                          touched,
                          errors,
                          "axaCategories"
                        )}`}
                      >
                        <option value="">SELECCIONA UNA OPCIÓN...</option>
                        {axas?.map((axa, idx) => (
                          <option key={idx} value={axa.axaCatDescription}>
                            {axa.axaCatDescription}
                          </option>
                        ))}
                      </Form.Control>
                      <ErrorMessage name="axaCategories">
                        {(msg) => (
                          <Form.Control.Feedback type="invalid">
                            {msg}
                          </Form.Control.Feedback>
                        )}
                      </ErrorMessage>
                    </Form.Group>
                  </Col>
                )}
              </Row>

              {/* Nivel Hospitalario — autopoblado por búsqueda reactiva contra catálogo de pólizas */}
              <Row>
                <Col md={6}>
                  <Form.Group controlId="hospitalCategory">
                    <Form.Label>Nivel Hospitalario</Form.Label>
                    <Form.Control
                      type="text"
                      name="hospitalCategory"
                      value={hospitalCategoryLookup.value}
                      readOnly
                      disabled={true}
                      placeholder={
                        hospitalCategoryLookup.status === "loading"
                          ? "Buscando…"
                          : "Se completa automáticamente al capturar la póliza"
                      }
                    />
                    {hospitalCategoryLookup.status === "notFound" && (
                      <Form.Text className="text-muted">
                        Sin nivel registrado para esta póliza.
                      </Form.Text>
                    )}
                    {hospitalCategoryLookup.status === "error" && (
                      <Form.Text className="text-danger">
                        No se pudo consultar el nivel hospitalario.
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              {/* Fila condicional (solo Programación de cirugía): Folio EP, Folio IH, Siniestro */}
              {isSurgery && (
                <Row>
                  <Col>
                    <Form.Group controlId="atentionIden">
                      <Form.Label>Folio EP *</Form.Label>
                      <Form.Control
                        type="text"
                        name="atentionIden"
                        value={values.atentionIden}
                        onChange={handleChange}
                        disabled={props.disabledAll}
                        className={`${getInputClasses(
                          touched,
                          errors,
                          "atentionIden"
                        )}`}
                      />
                      <ErrorMessage name="atentionIden">
                        {(msg) => (
                          <Form.Control.Feedback type="invalid">
                            {msg}
                          </Form.Control.Feedback>
                        )}
                      </ErrorMessage>
                    </Form.Group>
                  </Col>

                  <Col>
                    <Form.Group controlId="identificator">
                      <Form.Label>Folio IH *</Form.Label>
                      <Form.Control
                        type="text"
                        name="identificator"
                        value={values.identificator}
                        onChange={handleChange}
                        disabled={props.disabledAll}
                        className={`${getInputClasses(
                          touched,
                          errors,
                          "identificator"
                        )}`}
                      />
                      <ErrorMessage name="identificator">
                        {(msg) => (
                          <Form.Control.Feedback type="invalid">
                            {msg}
                          </Form.Control.Feedback>
                        )}
                      </ErrorMessage>
                    </Form.Group>
                  </Col>

                  <Col>
                    <Form.Group controlId="opinionIden">
                      <Form.Label>Siniestro *</Form.Label>
                      <Form.Control
                        type="text"
                        name="opinionIden"
                        value={values.opinionIden}
                        onChange={handleChange}
                        disabled={props.disabledAll}
                        className={`${getInputClasses(
                          touched,
                          errors,
                          "opinionIden"
                        )}`}
                      />
                      <ErrorMessage name="opinionIden">
                        {(msg) => (
                          <Form.Control.Feedback type="invalid">
                            {msg}
                          </Form.Control.Feedback>
                        )}
                      </ErrorMessage>
                    </Form.Group>
                  </Col>
                </Row>
              )}

              {/* Fila 4: Área de Ingreso, Fecha/Hora Ingreso, Folio Hospital, Cuarto */}
              <Row>
                <Col>
                  <Form.Group controlId="incomeAreaId">
                    <Form.Label>Área de Ingreso</Form.Label>
                    <Form.Control
                      as="select"
                      name="incomeAreaId"
                      value={values.incomeAreaId}
                      onChange={handleChange}
                      disabled={props.disabledAll}
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "incomeAreaId"
                      )}`}
                    >
                      <option value="">SELECCIONA UNA OPCIÓN...</option>
                      <option value="1">Urgencias</option>
                      <option value="2">HOSPITALIZACIÓN</option>
                      <option value="3">Ambulatorio</option>
                    </Form.Control>
                    <ErrorMessage name="incomeAreaId">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>

                <Col>
                  <Form.Group controlId="incomeDatetime">
                    <Form.Label>Fecha/ Hora Ingreso *</Form.Label>
                    <Form.Control
                      type="datetime-local"
                      name="incomeDatetime"
                      value={values.incomeDatetime.substring(0, 19)}
                      onBlur={(e) => {
                        let min = moment(timestamp).locale("es").subtract(30, "days").format().substring(0, 19);
                        let max = moment(timestamp).locale("es").add(1, "days").format().substring(0, 19);
                        let currentDateSelected = moment(e.target.value);
                        if (currentDateSelected.isSameOrAfter(min) && currentDateSelected.isSameOrBefore(max)) {
                          handleChange(e);
                        } else {
                          alert("Ingresa una fecha valida");
                          e.target.value = "";
                          handleChange(e);
                        }
                      }}
                      onChange={(e) => handleChange(e)}
                      min={moment(timestamp).locale("es").subtract(30, "days").format().substring(0, 19)}
                      max={moment(timestamp).locale("es").format().substring(0, 19)}
                      disabled={props.disabledAll}
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "incomeDatetime"
                      )}`}
                    />
                    <ErrorMessage name="incomeDatetime">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>

                <Col>
                  <Form.Group controlId="hospitalIden">
                    <Form.Label>Folio Hospital / Episodio *</Form.Label>
                    <Form.Control
                      type="text"
                      name="hospitalIden"
                      value={values.hospitalIden}
                      onChange={handleChange}
                      disabled={props.disabledAll}
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "hospitalIden"
                      )}`}
                    />
                    <ErrorMessage name="hospitalIden">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>

                <Col>
                  <Form.Group controlId="room">
                    <Form.Label>Cuarto</Form.Label>
                    <Form.Control
                      type="text"
                      name="room"
                      value={values.room}
                      onChange={handleChange}
                      disabled={props.disabledAll}
                      className={`${getInputClasses(touched, errors, "room")}`}
                    />
                    <ErrorMessage name="room">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>
              </Row>

              {/* Fila 5: Síntoma, Diagnóstico Presuntivo */}
              <Row>
                <Col>
                  <Form.Group controlId="symptom">
                    <Form.Label>Síntoma</Form.Label>
                    <Form.Control
                      type="text"
                      name="symptom"
                      value={values.symptom}
                      onChange={handleChange}
                      disabled={props.disabledAll}
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "symptom"
                      )}`}
                    />
                    <ErrorMessage name="symptom">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>

                <Col>
                  <Form.Group controlId="diagnosis">
                    <Form.Label>DIAGNÓSTICO Presuntivo *</Form.Label>
                    <Form.Control
                      type="text"
                      name="diagnosis"
                      value={values.diagnosis}
                      onChange={handleChange}
                      disabled={props.disabledAll}
                      className={`${getInputClasses(
                        touched,
                        errors,
                        "diagnosis"
                      )}`}
                    />
                    <ErrorMessage name="diagnosis">
                      {(msg) => (
                        <Form.Control.Feedback type="invalid">
                          {msg}
                        </Form.Control.Feedback>
                      )}
                    </ErrorMessage>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </>
        );
      }}
    </Formik>
  );
};
